module.exports = __webpack_public_path__ + "img/card_header_help_power.d71d919d.jpg";